import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { ExpOrgExtRouter } from './exp-org.router';
import { reducers } from './state/exp-org.selectors';

@NgModule({
  imports: [
    ExpOrgExtRouter,
    StoreModule.forFeature('expOrg', reducers),
  ],
  declarations: []
})
export class ExpOrgExtScreenModule { }